<template lang="pug">
div(data-test-id="segment-panels")
  SegmentSelectionPanel(
    v-model="segmentConfiguration.segments"
    :totalSelectedActiveSegments="totalSelectedActiveSegments"
    :pooled="pooled"
    @selectPooled="selectPooled"
    :disabled="disabled"
    )
  transition(name="fade")
    // hide mix settings for more than 2 segments
    div(v-if="!pooled && totalSelectedActiveSegments == 2")
      transition-group(name="segment")
        SegmentCard(v-for="(segment, index) in activeSegments" :key="segment.name" v-model="activeSegments[index]" :disabled="disabled")
      MixedBookingsPanel(v-if="activeSegments.length > 1" :segments="activeSegments" :disabled="disabled")
</template>

<script>
import SegmentSelectionPanel from './ResourceSegmentsTab/SegmentSelectionPanel.vue'
import SegmentCard from './ResourceSegmentsTab/SegmentCard.vue'
import MixedBookingsPanel from './ResourceSegmentsTab/MixedBookingsPanel.vue'
import modelMixin from '@v/mixins/modelMixin.js'

export default {
  name: 'ResourceSegmentsTab',
  components: {
    SegmentSelectionPanel,
    SegmentCard,
    MixedBookingsPanel,
  },
  mixins: [
    modelMixin({
      name: 'segmentConfiguration',
      type: Object,
      required: true,
    }),
  ],
  props: { disabled: Boolean },
  computed: {
    activeSegments() {
      return this.segmentConfiguration.segments.filter(s => s.active)
    },
    pooled: {
      get: function() {
        return this.segmentConfiguration.pooled
      },
      set: function(val) {
        this.segmentConfiguration.pooled = val
      },
    },
    totalSelectedActiveSegments() {
      return this.segmentConfiguration.segments.filter(s => s.active === true).length
    },
  },
  methods: {
    selectPooled(pooled) {
      this.pooled = pooled
      if (!pooled) this.setSegmentsToExclusive()
      if (!pooled && this.activeSegments.length > 2) this.setSegmentsPriorityToNull()
    },
    setSegmentsPriorityToNull() {
      for (const segment of this.activeSegments) {
        segment.priority = null
      }
    },
    setSegmentsToExclusive() {
      for (const segment of this.activeSegments) {
        segment.exclusive = true
      }
    },
  },
  mounted() {
    if (!this.pooled && this.activeSegments.length > 2) this.setSegmentsPriorityToNull()
  },
}
</script>

<style scoped lang="stylus">
.fade-entert-active, .fade-leave-active
  transition all .2s

.fade-enter, .fade-leave-to
  opacity 0

.segment-entert-active, .segment-leave-active
  transition all .2s

.segment-enter, .segment-leave-to
  opacity 0
  transform translateY(-30px)

.segment-move
  transition transform .2s ease-out
</style>
